import Navigator from '@navigator/index';
import { NavigationUrl, URLs } from '@navigator/NavigationUrl';

import { others51, others52, others53, others54, others55, others56, others57, others58, others59, others60, others61, others62, others63, others64, others65, others67, others68, others69, others70, others71, others72, others73, others74, others75, others76, others77, others78, others79, others80, others81, others82, } from '@theme/color';

export const sectionSetting = {
    slidesToSlide: 1,
    responsive: {
        bigDesktop: {
            breakpoint: {
                max: 3000,
                min: 1920,
            },
            items: 3.5,
            slidesToSlide: 2,
        },
        normalDesktop: {
            breakpoint: {
                max: 1919,
                min: 1160,
            },
            items: 2.75,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: {
                max: 1160,
                min: 960,
            },
            items: 2,
            width: 400,
            slidesToSlide: 1,
        },
        smallTablet: {
            breakpoint: {
                max: 960,
                min: 464,
            },
            items: 1.5,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: {
                max: 464,
                min: 0,
            },
            items: 1.25,
            slidesToSlide: 1,
        },
    },
};

export const groupSetting = {
    slidesToSlide: 1,
    responsive: {
        bigDesktop: {
            breakpoint: {
                max: 3000,
                min: 1920,
            },
            items: 3.5,
            slidesToSlide: 1,
        },
        normalDesktop: {
            breakpoint: {
                max: 1919,
                min: 1160,
            },
            items: 3.5,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: {
                max: 1160,
                min: 960,
            },
            items: 3,
            width: 400,
            slidesToSlide: 1,
        },
        smallTablet: {
            breakpoint: {
                max: 960,
                min: 464,
            },
            items: 2,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: {
                max: 464,
                min: 0,
            },
            items: 1.25,
            slidesToSlide: 1,
        },
    },
};


export enum ContentType {
    all = 'all',
    latest = 'latest',
    funding = 'funding',
    finance = 'finance',
    people = 'people',
    searchedData = 'searchedData'
};

export const ContentHeading = {
    all: "Latest Articles & Videos",
    latest: 'Latest',
    funding: "Funding",
    finance: "Finance",
    people: "People"
}

export const getContentDuration = (duration) => {
    if (duration?.value >= 60) {
        return `${Number(Math.floor(duration?.value / 60))} hr`;
    }else if(duration?.value===1){
        return `${Number(Math.floor(duration?.value))} ${(duration.type).slice(0, -1)}`;
    }
    else {
        return `${Number(Math.floor(duration?.value))} ${duration.type}`;
    }
}

export const groupCardColors = [
    {
        borderColor: others51,
        backgroundColor: others52
    },
    {
        borderColor: others53,
        backgroundColor: others54
    },
    {
        borderColor: others55,
        backgroundColor: others56
    },
    {
        borderColor: others57,
        backgroundColor: others58
    },
    {
        borderColor: others59,
        backgroundColor: others60
    },
    {
        borderColor: others61,
        backgroundColor: others62
    },
    {
        borderColor: others63,
        backgroundColor: others64
    },
    {
        borderColor: others65,
        backgroundColor: others58
    },
    {
        borderColor: others67,
        backgroundColor: others68
    },
    {
        borderColor: others69,
        backgroundColor: others70
    },
    {
        borderColor: others71,
        backgroundColor: others72
    },
    {
        borderColor: others73,
        backgroundColor: others74
    },
    {
        borderColor: others75,
        backgroundColor: others76
    },
    {
        borderColor: others77,
        backgroundColor: others78
    },
    {
        borderColor: others79,
        backgroundColor: others80
    },
    {
        borderColor: others81,
        backgroundColor: others82
    },
    {
        borderColor: others51,
        backgroundColor: others52
    },
    {
        borderColor: others53,
        backgroundColor: others54
    },
    {
        borderColor: others55,
        backgroundColor: others56
    },
    {
        borderColor: others57,
        backgroundColor: others58
    },
    {
        borderColor: others59,
        backgroundColor: others60
    },
];

const navigateToHomePage = () => {
    Navigator.push(NavigationUrl.generate(URLs.library));
};
export const onClickGoBack = (history) => {
    if (history.length>1) {
        history.goBack()
    } else {
        navigateToHomePage()
    }
};

export enum ContentType {
    TEMPLATE = 'template',
    TEXT = 'text'
}

export enum TemplateType {
    PDF = 'pdf',
    DOC = 'doc',
    DOCX = 'docx',
    PPTX = 'pptx',
    PPT = 'ppt',
    XLSX = 'xlsx',
    XLS = 'xls',
    PNG = 'png',
    JPEG = 'jpeg',
    JPG = 'jpg'
}

export enum TagType {
    GROUP = 'group',
    VALUE = 'value'
}

export enum highlightPath {
    BODY = 'body',
    TITLE = 'title',
    TAG = 'tag'
}

export enum highlightObjKeys{
    TEXT = 'text',
    HIT = 'hit'
}
